import { XSGlobalHeaderActions } from '@xinosolutions/xs-shell';
import { useAccountMenuUser, useAuthActions } from '@xinosolutions/xs-auth-react';
import { useAdminLogout } from '../../Hooks/useAdminLogout';

const DEFAULT_MANAGE_ACCOUNT_URL =
  import.meta.env.VITE_XS_ACCOUNT_URL?.trim() || 'https://account.xinosolutions.com/dashboard';

/**
 * Same account control as xs-bookly-web-app / xs-sites-web-app
 * (XSGlobalHeaderActions from @xinosolutions/xs-shell).
 */
export default function ShellAccountActions({
  manageAccountUrl = DEFAULT_MANAGE_ACCOUNT_URL,
  manageAccountLabel = 'Manage your XS Account',
  beforeAccount,
}) {
  const menuUser = useAccountMenuUser();
  const { switchAccount, addAccount, pending } = useAuthActions({
    notifyError: true,
  });
  const { signOut, pending: signOutPending } = useAdminLogout({
    homePath: '/',
  });

  return (
    <XSGlobalHeaderActions
      user={menuUser}
      manageAccountUrl={manageAccountUrl}
      manageAccountLabel={manageAccountLabel}
      beforeAccount={beforeAccount}
      onSwitchAccount={() => {
        switchAccount().catch(() => {});
      }}
      onAddAccount={() => {
        addAccount().catch(() => {});
      }}
      onSignOut={() => {
        signOut().catch(() => {});
      }}
      switchPending={pending}
      signOutPending={signOutPending}
    />
  );
}
